document.addEventListener('DOMContentLoaded', () => {
    function shouldOpenPdfInModal($el) {
        if (!$el.classList.contains('modal-pdf')) {
            return true;
        }

        return !/Android/i.test(window.navigator.userAgent || '');
    }

    // Functions to open and close a modal
    function openModal($el) {
        $el.classList.add('is-active');

        if ($el.classList.contains('modal-video')) {
            let $video = $el.querySelector('iframe');
            if ($video.hasAttribute('data-src')) {
                $video.src = $video.getAttribute('data-src');
            }
        }
        //if ($el.id === 'modal-search') {
        //    document.getElementsByName('q')[0].focus();
        //}

        //document.querySelector('html').classList.add('is-clipped');
    }

    function closeModal($el) {
        $el.classList.remove('is-active');

        if ($el.classList.contains('modal-video')) {
            let $video = $el.querySelector('iframe');
            if ($video.hasAttribute('data-src') || $video.hasAttribute('src')) {
                $video.dataset.src = $video.src;
                $video.src = '';
            }
        }

        document.querySelector('html').classList.remove('is-clipped');
    }

    function closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(($modal) => {
            closeModal($modal);
        });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
        const modal = $trigger.dataset.target;
        const $target = document.getElementById(modal);

        $trigger.addEventListener('click', (event) => {
            if (!$target || !shouldOpenPdfInModal($target)) {
                return;
            }

            event.preventDefault();
            openModal($target);
        });
    });

    // Add a click event on various child elements to close the parent modal
    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
        const $target = $close.closest('.modal');

        $close.addEventListener('click', () => {
            closeModal($target);
        });
    });

    // Add a keyboard event to close all modals
    document.addEventListener('keydown', (event) => {
        const e = event || window.event;

        if (e.keyCode === 27) { // Escape key
            closeAllModals();
        }
    });
});
